import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { enqueueSnackbar } from 'notistack';
import { UserNotification } from '@api/notifications/interfaces';
import { useMarkMyNotificationRead } from '@reactQuery/notifications';
import { getNotificationPath } from '@notifications/registry';

export const useOpenNotification = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { mutateAsync: markRead } = useMarkMyNotificationRead();

  return useCallback(
    async (notification: UserNotification): Promise<void> => {
      const path = getNotificationPath(notification);

      try {
        await markRead(notification.id);
      } catch {
        enqueueSnackbar(t('notifications:unavailable'), { variant: 'error' });
        return;
      }

      if (!path) {
        enqueueSnackbar(t('notifications:unavailable'), {
          variant: 'warning',
        });
        return;
      }

      navigate(path);
    },
    [markRead, navigate, t]
  );
};
